'use client';
import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgEntertainment = function SvgEntertainment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.373 3.036c2.399.435 4.856.435 7.254 0A2.027 2.027 0 0 1 21 5.049v3.955A5.997 5.997 0 0 1 15 15a6 6 0 0 1-6-5.997V5.049a2.027 2.027 0 0 1 2.373-2.013M7.5 17.464A2.64 2.64 0 0 1 8.971 17c.549.006 1.083.18 1.529.5M7.5 13.223h-1M13.5 7h-1M17.5 7h-1",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.5 11.036a2.64 2.64 0 0 1-1.471.464A2.67 2.67 0 0 1 13.5 11M9 9.362a19.7 19.7 0 0 1-3.627-.327A2.03 2.03 0 0 0 3 11.053V15a6 6 0 0 0 12 0",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgEntertainment as default };
//# sourceMappingURL=entertainment.svg.js.map
